import React from "react";
import {NavLink} from "react-router-dom";

export const FooterComponent = () => {
    return (
        <div className="footer d-flex justify-content-between align-items-center">
            <div>
                <strong>Copyright</strong> FINKI &copy; 2020
            </div>
            <NavLink className='btn btn-success' to={'about-us'}>Credits</NavLink>
        </div>
    )
}
